export default __webpack_public_path__ + "static/media/beauty_2020_OV_seemore_EH-NA98-K_2_201127.b020381a.jpg";